export default "__VITE_ASSET__1040efc8__"